import { Card, CardContent, CardHeader } from '../Card'
import Image from '../Image'

type DocumentMeta = {
  path: string
  student_id?: number | null
  invoice_number?: string | null
  invoice_date?: string | null
  invoice_amount?: string | number | null
  notes?: string | null
}

type StudentRef = {
  student_id?: number
  student_name: string
}

type Props = {
  documents: DocumentMeta[]
  students?: StudentRef[]
  title?: string
}

export function DocumentsViewer({
  documents,
  students,
  title = 'Documents',
}: Props) {
  if (documents.length === 0) {
    return null
  }

  return (
    <Card>
      <CardHeader>
        <h2 className="text-lg font-bold">{title}</h2>
      </CardHeader>
      <CardContent>
        <div className="flex gap-4 flex-wrap">
          {documents.map((doc) => {
            const studentName =
              doc.student_id != null
                ? (students?.find((s) => s.student_id === doc.student_id)
                    ?.student_name ?? `ID: ${doc.student_id}`)
                : null

            const hasMetadata =
              studentName ||
              doc.invoice_number ||
              doc.invoice_date ||
              doc.invoice_amount != null ||
              doc.notes

            return (
              <div key={doc.path} className="flex flex-col gap-2">
                <Image
                  allowZoom={true}
                  className="object-cover h-32 w-32"
                  path={doc.path}
                />
                {hasMetadata && (
                  <div className="text-xs text-gray-600 w-32 space-y-1">
                    {studentName && (
                      <div>
                        <span className="font-medium">Student:</span>{' '}
                        {studentName}
                      </div>
                    )}
                    {doc.invoice_number && (
                      <div>
                        <span className="font-medium">Invoice #:</span>{' '}
                        {doc.invoice_number}
                      </div>
                    )}
                    {doc.invoice_date && (
                      <div>
                        <span className="font-medium">Date:</span>{' '}
                        {doc.invoice_date}
                      </div>
                    )}
                    {doc.invoice_amount != null && (
                      <div>
                        <span className="font-medium">Amount:</span> $
                        {doc.invoice_amount}
                      </div>
                    )}
                    {doc.notes && (
                      <div>
                        <span className="font-medium">Notes:</span> {doc.notes}
                      </div>
                    )}
                  </div>
                )}
              </div>
            )
          })}
        </div>
      </CardContent>
    </Card>
  )
}
